import {
  Box,
  Divider,
  Flex,
  HStack,
  Show,
  Stack,
  useToast,
} from '@chakra-ui/react';
import { EditPayload, EditUser } from '@diamond/shared/types';
import { UserDetail } from '@diamond/shared/types';
import { Button, Checkbox, showToast, Text } from '@diamond/shared/ui';
import { useUserManagementData } from '@diamond/sol-buyer-context';
import { SubmitHandler, useForm } from 'react-hook-form';
import InfiniteScroll from 'react-infinite-scroll-component';

export interface EditUserModalProps {
  onSubmit: (values: EditUser) => void;
  onClose: () => void;
  userDetail: UserDetail;
}

type FormValues = {
  shiptos: string[];
};

export function EditUserModal(props: EditUserModalProps) {
  const { shiptoData, setShiptoSize } = useUserManagementData();
  const toast = useToast();

  const userDetail = props.userDetail;

  const { register, handleSubmit } = useForm<FormValues>();

  const onSubmit: SubmitHandler<FormValues> = (values) => {
    const idToast = 'select-shiptos';
    if (!values.shiptos || values.shiptos.length === 0) {
      if (!toast.isActive(idToast)) {
        showToast(toast, 'error', 'Pilih minimal 1 ship to', idToast, 'top');
      }
    } else {
      const checkedShipto = shiptoData?.data.filter((value) =>
        values.shiptos?.includes(value?.id)
      );
      const checkedPayload = checkedShipto?.map(
        (value: Omit<EditPayload, 'is_selected'>) => {
          return {
            id: value.id,
            name: value.name,
            is_selected: true,
          };
        }
      );
      const payload = {
        shiptos: [...(checkedPayload as EditPayload[])],
      };
      props.onSubmit(payload);
      props.onClose();
    }
  };

  return (
    <Box>
      <Show breakpoint="(max-width: 768px)">
        <Divider borderWidth="1px" mb="4" mt={-2} />
      </Show>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Stack mb="8">
          <Flex>
            <Box w="40%" fontWeight="bold">
              <Text>Email</Text>
              <Text>Nama Depan</Text>
              <Text>Nama Belakang</Text>
            </Box>
            <Box w="full">
              <Text>: {userDetail.email}</Text>
              <Text>: {userDetail.first_name}</Text>
              <Text>: {userDetail.last_name}</Text>
            </Box>
          </Flex>
          <Text fontWeight="bold">Pilih Ship to:</Text>
          <InfiniteScroll
            dataLength={shiptoData.data.length}
            next={() => setShiptoSize(shiptoData.data.length + 10)}
            hasMore={shiptoData.data.length < shiptoData.pagination.rows}
            loader={<h4>Loading...</h4>}
            height={300}
          >
            <Box>
              {userDetail.shiptos.map((val) => (
                <Checkbox
                  key={val.id}
                  name="shiptos"
                  label={val.name}
                  value={val.id}
                  register={register}
                  defaultChecked={val.is_selected}
                />
              ))}
            </Box>
          </InfiniteScroll>
        </Stack>

        <Divider borderWidth="1px" mb="4" mt={6} />
        <Box mt={6} mb={1}>
          <HStack w="full" alignContent="space-between">
            <Button onClick={props.onClose} w="full">
              Tutup
            </Button>
            <Button variant="solid" type="submit" w="full">
              Simpan
            </Button>
          </HStack>
        </Box>
      </form>
    </Box>
  );
}
